module.exports = __webpack_public_path__ + "img/Cryptanalysis.c91c66b0.jpeg";